import React, { memo } from 'react'
import tw from 'twin.macro'
import { Chip } from 'src/components/shared/Chip'
import {
  InternalRoleType,
  internalRoleTypeTitles,
} from 'src/constants/internal-access/internalRoles'
import type { InternalAccessRole } from 'src/interfaces/internalAccess'
import { resolveInternalRoleType } from 'src/utils/internalAccess/internalRoles'

interface Props {
  role: InternalAccessRole
}

/** Custom roles (admin-created, fully editable) stand out; System and Built-in stay grey. */
const InternalRoleTypeChipComponent = ({ role }: Props) => {
  const roleType = resolveInternalRoleType(role)

  if (roleType === InternalRoleType.Custom) {
    return (
      <Chip
        text={internalRoleTypeTitles[roleType]}
        className={tw`bg-primary-100`}
        textClassName={tw`text-primary-700`}
        dataTestId="internal-role-type-custom"
      />
    )
  }

  return (
    <Chip
      text={internalRoleTypeTitles[roleType]}
      className={tw`bg-shades-100`}
      textClassName={tw`text-shades-700`}
      dataTestId={`internal-role-type-${roleType}`}
    />
  )
}

export const InternalRoleTypeChip = memo(InternalRoleTypeChipComponent)
